export default __webpack_public_path__ + "static/media/application-need-idea-500.eb49f561.png";